import * as React from "react";
import { DestinationSelectorProps } from "../typings";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { Layer, ViewExtraLarge, ViewLarge, ViewMedium, Viewport, ViewSmall } from "bernie-view";
import { DestinationSelectorCard } from "./DestinationSelectorCard";
import { DialogRoute } from "bernie-core";
import { inject } from "mobx-react";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";

export const DestinationSelector = inject("routeStore")((props: DestinationSelectorProps) => {
  const [informationButtonRef, setRef] = React.useState<HTMLButtonElement | null>(null);
  const flexComponent = props.flexComponent;
  const keyHelper = new ItemKeyHelper(props.flexComponent.id);
  const moduleName = flexComponent.name;
  const analytics = props.analytics;
  const destinationSelectorDialogId = "destination-dialog";
  const { formatText } = useLocalization();
  const openDialog = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    buttonToFocus: React.RefObject<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setRef(buttonToFocus?.current);

    return props.routeStore && props.routeStore.updateSearch({ pwaDialog: destinationSelectorDialogId });
  };

  const closeDialog = () => {
    if (informationButtonRef) {
      informationButtonRef.focus();
    }

    return props.routeStore && props.routeStore.closeDialog();
  };

  return (
    <div
      className="DestinationSelector uitk-cell all-cell-1-1 all-l-padding-three all-y-padding-three"
      id={flexComponent.model.name}
      data-testid={`DestinationSelector-${flexComponent.model.predefinedAffinity}`}
    >
      <DialogRoute id={destinationSelectorDialogId}>
        <Layer id="destination-selector-dialog" onDismiss={closeDialog}>
          <UitkDialog dialogShow={true}>
            <UitkDialogContent>
              <p className="uitk-type-paragraph-300">{formatText("DestinationsByAffinity.priceStatement")}</p>
            </UitkDialogContent>
            <UitkDialogFooter
              buttonOne={{
                onClick: closeDialog,
                text: formatText("DestinationsByAffinity.priceDialogCloseButton"),
                type: "tertiary",
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
      <UitkLayoutGrid columns={6} space="three">
        <Viewport>
          <ViewSmall>
            <>
              {flexComponent.model.destinations.map((destination, index) => {
                return (
                  <UitkLayoutGridItem colSpan={6} key={keyHelper.next()}>
                    <div>
                      <DestinationSelectorCard
                        destination={destination}
                        index={index}
                        isTablet={false}
                        moduleName={moduleName}
                        analytics={analytics}
                        affinity={flexComponent.model.predefinedAffinity}
                        dialogShowOnClick={openDialog}
                      />
                    </div>
                  </UitkLayoutGridItem>
                );
              })}
            </>
          </ViewSmall>
          <ViewMedium>
            <>
              {flexComponent.model.destinations.map((destination, index) => {
                return (
                  <UitkLayoutGridItem colSpan={6} key={keyHelper.next()}>
                    <div>
                      <DestinationSelectorCard
                        destination={destination}
                        index={index}
                        isTablet={true}
                        moduleName={moduleName}
                        analytics={analytics}
                        affinity={flexComponent.model.predefinedAffinity}
                        dialogShowOnClick={openDialog}
                      />
                    </div>
                  </UitkLayoutGridItem>
                );
              })}
            </>
          </ViewMedium>
          <ViewLarge>
            <>
              {flexComponent.model.destinations.map((destination, index) => {
                return (
                  <UitkLayoutGridItem colSpan={3} key={keyHelper.next()}>
                    <div>
                      <DestinationSelectorCard
                        destination={destination}
                        index={index}
                        isTablet={false}
                        moduleName={moduleName}
                        analytics={analytics}
                        affinity={flexComponent.model.predefinedAffinity}
                        dialogShowOnClick={openDialog}
                      />
                    </div>
                  </UitkLayoutGridItem>
                );
              })}
            </>
          </ViewLarge>
          <ViewExtraLarge>
            <>
              {flexComponent.model.destinations.map((destination, index) => {
                return (
                  <UitkLayoutGridItem colSpan={2} key={keyHelper.next()}>
                    <div>
                      <DestinationSelectorCard
                        destination={destination}
                        index={index}
                        isTablet={false}
                        moduleName={moduleName}
                        analytics={analytics}
                        affinity={flexComponent.model.predefinedAffinity}
                        dialogShowOnClick={openDialog}
                      />
                    </div>
                  </UitkLayoutGridItem>
                );
              })}
            </>
          </ViewExtraLarge>
        </Viewport>
      </UitkLayoutGrid>
    </div>
  );
});
